<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="idPerfil == 1 ? 1 : 3" />
    <h4>Usuarios</h4>
    <hr />

<DataTable
  :data="usuarios"
  :columns="columnas"
  idField="idUsuario"
  mensajeVacio="No hay registros de usuarios."
  :mostrarBotonTodos="false"
  :mostrarBotonNuevo="false"
  :mostrarEditar="opcionMenu == 1"
  :mostrarVer="idPerfil == 1"
  :mostrarEliminar="idPerfil == 1"
  @refresh="cargarUsuarios()"
  @edit="row => abrirModalEditar(row.idUsuario)"
  @view="row => abrirEditar(row.idUsuario)"
  @delete="row => deleteUsuario(row.idUsuario)"
>
  <template #acciones-extra>
    <div class="col-auto" v-if="idPerfil == 1">
      <router-link to="/persona-usuario" class="btn btn-primary btn-sm d-flex align-items-center gap-1">
        <span class="material-icons" style="font-size:16px">person_add</span>
        Ir a Creación de Usuarios
      </router-link>
    </div>	  
  </template>
  <template #acciones-fila="{ row }" v-if="opcionMenu == 1">
    <button class="btn btn-sm btn-outline-secondary" @click="datosPersona(row.idUsuario)" title="Datos Persona">
      <span class="material-icons" style="font-size:14px">person</span>
    </button>
  </template>
</DataTable>

<!-- ── Modal ──────────────────────────────────────────────────── -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title text-white">{{ titulo }}</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <div class="row">
            <div class="col-3"><label class="form-label fw-bold">ID Usuario</label></div>
            <div class="col-9">
              <input type="text" class="form-control" v-model="datoUsuario.idUsuario" disabled />
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-3"><label class="form-label fw-bold">Empresa</label></div>
            <div class="col-9">
              <select class="form-select" v-model="datoUsuario.idEmpresa" :disabled="datoUsuario.idUsuario != null">
                <option disabled value="">Seleccione...</option>
                <option v-for="e in empresas" :key="e.idEmpresa" :value="e.idEmpresa">{{ e.nombreCorto }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-3"><label class="form-label fw-bold">Perfil</label></div>
            <div class="col-9">
              <select class="form-select" v-model="datoUsuario.idPerfil" @change="aplicarPermisosPerfil">
                <option disabled value="">Seleccione...</option>
                <option v-for="p in perfils" :key="p.idPerfil" :value="p.idPerfil">{{ p.nombre }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-3"><label class="form-label fw-bold">Nombre</label></div>
            <div class="col-9">
              <input type="text" class="form-control" v-model="datoUsuario.nombre"/>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="row">
            <div class="col-3"><label class="form-label fw-bold">Fecha Registro</label></div>
            <div class="col-3">
              <input type="text" class="form-control" v-model="datoUsuario.fechaReg" disabled />
            </div>
            <div class="col-3"><label class="form-label fw-bold">Fecha Act.</label></div>
            <div class="col-3">
              <input type="text" class="form-control" v-model="datoUsuario.fechaAct" disabled />
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-header bg-secondary text-white py-1 d-flex justify-content-between align-items-center">
            <span class="small fw-bold">Permisos de módulos y menús</span>
            <small class="text-white-50">Al seleccionar un perfil se cargan automáticamente</small>
          </div>
          <div class="card-body py-2">
            <div class="row g-2">
              <div class="col-6 col-md-4" v-for="campo in camposModulos" :key="campo.field">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" :id="campo.field"
                    :true-value="1" :false-value="0" v-model="datoUsuario[campo.field]" />
                  <label class="form-check-label small" :for="campo.field">{{ campo.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-warning" @click.prevent="actualizarUsuario">
          <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
          Actualizar
        </button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>

    <Footer />
  </div>
</template>

<script>
import Layout     from "@/components/Layout.vue";
import Footer     from "@/components/Footer.vue";
import DataTable  from "@/components/DataTable.vue";
import api        from "@/services/api";
import { validarForm2 } from "@/modules/validacionesForms.js";
import Swal       from "sweetalert2";
import * as $     from "jquery";
window["$"] = $; window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      usuarios:        [],
      empresas:        [],
      perfils:         [],
      datoUsuario:     {},
      empresaBusqueda: "",
      perfilBusqueda:  "",
      nombreBusqueda:  "",
      titulo:          "",
      btnEditar:       false,
      modalWindow:     true,
      idPerfil:        0,
      opcionConsulta:  0,
      opcionMenu:      0,
      camposModulos: [
        { label: "Módulo Administración", field: "moduloAdministracion" },
        { label: "Módulo Atención",       field: "moduloAtencion"       },
        { label: "Módulo Auditoría",      field: "moduloAuditoria"      },
        { label: "Módulo Facturación",    field: "moduloFacturacion"    },
        { label: "Módulo Dashboards",     field: "moduloDashboards"     },
        { label: "Menú Parámetros",       field: "menuParametros"       },
        { label: "Menú Procesos",         field: "menuProcesos"         },
        { label: "Menú Reportes",         field: "menuReportes"         },
        { label: "Menú Ayuda",            field: "menuAyuda"            },
        { label: "Opción Consulta",       field: "opcionConsulta"       },
        { label: "Opción Operaciones",    field: "opcionOperaciones"    },
        { label: "Opción Descarga",       field: "opcionDescarga"       },
        { label: "Opción Menú",           field: "opcionMenu"           },
        { label: "Reporte Obs. y Resp.",  field: "reporteObsResp"       },
        { label: "Reporte Obs. Reexp.",   field: "reporteObsReex"       },
        { label: "Reporte Carga",         field: "reporteCarga"         },
        { label: "Reporte Resumen",       field: "reporteResumen"       },
      ],
    };
  },
  computed: {
    columnas() {
      const cols = [];
      if (this.idPerfil == 1) cols.push({ label: "Empresa", field: "empresaNombreCorto" });
      cols.push(
        { label: "Nombre",  field: "nombre"       },
        { label: "Perfil",  field: "perfilNombre"  },
        { label: "Persona", field: "personaNombre" },
      );
      return cols;
    },
  },
  mounted() {
    this.idPerfil       = Number(window.sessionStorage.getItem("idPerfil"));
    this.opcionConsulta = parseInt(window.sessionStorage.getItem("opcionConsulta"), 10) || 0;
    this.opcionMenu     = parseInt(window.sessionStorage.getItem("opcionMenu"),     10) || 0;
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarUsuarios();
    this.getEmpresas();
    this.getPerfils();
    // ← validarCreacionUsuario eliminado
  },
  methods: {
    cargarUsuarios() {
      const idEmpresa = window.sessionStorage.getItem("idEmpresa");
      const endpoint  = this.idPerfil == 1
        ? `/vwusuarios`
        : `/vwusuarios/idempresa/${idEmpresa}`;

      api.get(endpoint)
        .then(r => { this.usuarios = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar usuarios:", e));
    },
    getEmpresas() {
      api.get("/vwempresas").then(r => { this.empresas = r.data; });
    },
    getPerfils() {
      api.get("/vwperfils").then(r => { this.perfils = r.data; });
    },
    validarForm() {
      const fields = [
        "idPerfil","nombre",
        "moduloAdministracion","moduloAtencion","moduloAuditoria","moduloFacturacion","moduloDashboards",
        "menuParametros","menuProcesos","menuReportes","menuAyuda",
        "opcionConsulta","opcionOperaciones","opcionDescarga","opcionMenu",
      ];
      return validarForm2(this.datoUsuario, fields, fields);
    },
    async actualizarUsuario() {
      if (this.validarForm() !== 1) return;
      try {
        this.datoUsuario.idUsuarioAct = window.sessionStorage.getItem("idUsuario");
        await api.post("/usuarios", this.datoUsuario);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Usuario actualizado exitosamente." });
        this.cargarUsuarios();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deleteUsuario(idUsuario) {
      const confirm = await Swal.fire({
        title: "¿Eliminar usuario?", text: "Esta acción no se puede deshacer.",
        icon: "warning", showCancelButton: true,
        confirmButtonText: "Sí, eliminar", cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/usuarios/" + idUsuario);
        this.cargarUsuarios();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    async abrirModalEditar(idUsuario) {
      this.modalWindow = true;
      this.titulo      = "Editar Usuario";
      this.btnEditar   = true;
      try {
        const resp       = await api.get("/vwusuarios/" + idUsuario);
        this.datoUsuario = resp.data;
      } catch (e) {
        console.error("Error al cargar usuario:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
    abrirEditar(idUsuario) {
      if (idUsuario != null) this.$router.push("/usuarioform/" + idUsuario);
    },
    datosPersona(idUsuario) {
      if (idUsuario != null) this.$router.push("/personaform/" + idUsuario);
    },
    aplicarPermisosPerfil() {
      const perfil = this.perfils.find(p => p.idPerfil === this.datoUsuario.idPerfil);
      if (!perfil) return;
      this.camposModulos.forEach(c => { this.datoUsuario[c.field] = perfil[c.field] ?? 0; });
    },
  },
};
</script>